export function Logo({ size = 40, withText = true, className = "", variant = "blue" }) {
  const src = variant === "white" ? "/atlas-logo-white.png" : "/atlas-logo-blue.png";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="ATLAS — Sucofindo EPISI"
        width={size}
        height={size}
        style={{ height: size, width: "auto" }}
        className="select-none"
      />
      {withText ? (
        <div className="leading-tight">
          <div className={`font-display text-[15px] font-extrabold tracking-tight ${variant === "white" ? "text-white" : "text-slate-900"}`}>
            ATLAS
          </div>
          <div className={`text-[10px] uppercase tracking-[0.22em] ${variant === "white" ? "text-teal-200" : "text-teal-700"}`}>
            Sucofindo EPISI
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Logo;
